import { Directive, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { CanDeactivateComponent } from './types';
import { CanDeactivateNotification } from './can-deactivate.notification.service';

@Directive({
  selector: 'router-outlet',
  standalone: false,
})
export class SgRouterOutletCanDeactivateDirective {
  @HostListener('window:beforeunload', ['$event'])
  canDeactivate($event: any) {
    for (const component of this.components) {
      if (typeof component.canDeactivate === 'function' && !component.canDeactivate()) {
        if (!this.canDeactivateService.canDeactivate()) {
          $event.returnValue = true;
          return;
        }
      }
    }
  }

  private components: CanDeactivateComponent[] = [];

  constructor(
    routerOutlet: RouterOutlet,
    private canDeactivateService: CanDeactivateNotification
  ) {
    routerOutlet.activateEvents.subscribe((c) => this.components.push(c));
    routerOutlet.deactivateEvents.subscribe((c) => {
      const idx = this.components.indexOf(c);
      if (idx > -1) {
        this.components.splice(idx, 1);
      }
    });
  }
}
